/**
 * Unauthorized Throwable Error
 */
export class Unauthorized extends Error {
  constructor ({ entitlementName, actionName } = {}, ...params) {
    super(...params)
    this.name = '[Entitlements::Unauthorized]'
    this._entitlementName = entitlementName
    this._actionName = actionName
  }

  toString () {
    return this._actionName && this._entitlementName
      ? `You don't have permissions to perform '${this._actionName}' on '${this._entitlementName}'.`
      : this._entitlementName
        ? `You don't have permissions to perform any action on '${this._entitlementName}'.`
        : 'Insufficient Permissions.'
  }
}

/**
 * InvalidEntitlement Throwable Error
 */
export class InvalidEntitlement extends Error {
  constructor ({ entitlements, message }, ...params) {
    super(...params)
    this.name = '[Entitlements::InvalidEntitlement]'
    this._entitlements = entitlements
    this._message = message
  }

  toString () {
    return `Invalid entitlements: ${this._message} (${this._entitlements instanceof Object ? JSON.stringify(this._entitlements) : this._entitlements}).`
  }
}
